import React from 'react';
import PropTypes from 'prop-types';
import { catalogueUrl } from '../../helpers/urlBuilder';
import Svg from 'rp-react-svg-icon';

const rootData = document.getElementById('root').dataset || {};

/**
 * Cell contains link to sales results catalogue
 *
 * @param {{}} props
 * @constructor
 */
const StatisticsSalesDayCell = (props) => {
    const salesDate = props.rowData[props.customCell.options.columnDate];
    if (salesDate) {
        return (
            <a
                href={catalogueUrl(
                    rootData.venueid,
                    rootData.salesdatestart,
                    {
                        from: salesDate,
                        to: salesDate,
                    }
                )}
                className="ui-link ui-link_table"
            >
                {props.rowData[props.columnName]}
                <Svg
                    iconName="right"
                    size="XSmall"
                />
            </a>
        );
    }

    return <span>{props.rowData[props.columnName]}</span>;
};

StatisticsSalesDayCell.propTypes = {
    /**
     * Single row data
     */
    rowData: PropTypes.object.isRequired,
    /**
     * Name of current column
     */
    columnName: PropTypes.string.isRequired,
    /**
     * Custom cell component and options
     */
    customCell: PropTypes.object.isRequired
};

export default StatisticsSalesDayCell;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/StatisticsSalesDayCell.js